<template>
    <div style="height: 100%">
        <Box title="仓库选择">
            <div class="content">
                <div class="items" @click="showDiaLog = true">
                    <span>仓库</span>
                    <span>{{StoreName}}</span>
                    <img src="../../assets/img/right.png">
                </div>
            </div>
            <div class="ChangeHome" @click="ChangeHome">选择</div>
        </Box>
        <van-popup v-model="showDiaLog" position="bottom" :style="{ height: '50%', borderRadius: '10px 10px 0 0'}">
            <div class="picker-header">
                <span @click="showDiaLog = false">取消</span>
                <span @click="confirm">确定</span>
            </div>
            <van-picker :columns="actions" @cancel="showPicker = false" @change="onChange" :default-index="actionsDefaultIndex"
                item-height="15vw" swipe-duration="500" />
        </van-popup>
    </div>
</template>

<script>
    import Vue from 'vue'
    import Box from '@/components/commonBox/commonBox'
    import {
        Toast,
        Popup,
        Picker
    } from 'vant';
    export default {
        name: 'STORE',
        data() {
            return {
                showDiaLog: false, //  是否显示弹窗
                actions: [], //  滑块选项
                selectActions: '', //  选中的仓库
                actionsDefaultIndex: 0, //  滑块初始选中index
                vStoreList: null, //仓库集合对象
                StoreName: '' ,//显示仓库名称,
            }
        },
        components: {
            Box,
            [Popup.name]: Popup,
            [Picker.name]: Picker
        },
        mounted() {
            this.loadSTORE();//初始化滑块选中index
        },
        methods: {
            onChange(picker, value, index) {
                this.selectActions = value
            },
            confirm() {//弹出层   选择事件
                this.StoreName = !!this.selectActions?this.selectActions:this.actions[0];
                this.showDiaLog = false;
            },
            loadSTORE() {
                this.$get('/api/Login/WarehouseList', {
                            UserCode:this.$UserInfo.UserId,
                            Token: 'YTDF5EF3A6174564E5981A446158F106'
                    })
                    .then(result => {
                        let model=result.WarehouseList,data=[];
                        for(let i=0;i<model.length;i++){
                            if(model[i].Have)
                            {
                                data.push(model[i]);
                                this.actions.push(model[i].StoreName);
                            }
                        }
                        if (data.length === 0) {
                            this.$Toast("您目前没有可选择的仓库，请联系管理员分配仓库!");
                        } else if (data.length === 1) {
                            this.$UserInfo.StoreName=data[0].StoreName;
                            this.$UserInfo.StoreCode=data[0].StoreId;
                            localStorage.setItem('userInfo',JSON.stringify(this.$UserInfo));
                            this.$router.push('/');
                        } else if (data.length > 1) {
                            this.StoreName=this.actions[0];
                            this.vStoreList = model;
                        }
                    }).catch(err => {
                        console.log('请求失败：' + err.status + ',' + err.statusText);
                    });
            },
            ChangeHome() {
                if (!this.StoreName) {
                    this.$Toast("请先选择仓库!");
                    return;
                }
                for (let i = 0; i < this.vStoreList.length; i++) {
                    if (this.vStoreList[i].StoreName === this.StoreName) {
                        this.$UserInfo.StoreName=this.vStoreList[i].StoreName;
                        this.$UserInfo.StoreCode=this.vStoreList[i].StoreId;
                        Vue.prototype.$UserInfo=this.$UserInfo;
                        localStorage.setItem('userInfo',JSON.stringify(this.$UserInfo));//重新存放User对象
                        this.showDiaLog = false;
                        break;
                    }
                }
                this.$router.push('/');
            }
        }
    }
</script>

<style scoped lang="scss">
    .content {
        margin-top: 38% !important;
        background: $BACKGROUND-COLOR;
        border-radius: 12px;
        padding: 0 28px 0 40px !important;
        box-sizing: border-box;

        .items {
            display: flex;
            height: 110px;
            border-bottom: 2px solid #F3F3F3;
            font-size: 29px;
            color: $TEXT-DARK-COLOR;
            align-items: center;

            span {
                &:first-child {
                    flex: 1;
                }
            }

            img {
                width: 32px;
                margin-left: 6px;
            }
        }
    }

    .ChangeHome {
        width: 600px;
        height: 100px;
        border-radius: 12px;
        background: $THEME-COLOR;
        line-height: 100px;
        text-align: center;
        font-size: 32px;
        color: $TEXT-LIGHT-COLOR;
        margin-left: 70px;
        margin-top: 28px;
    }
</style>



// WEBPACK FOOTER //
// src/page/STORE/STORE.vue